import { webStorage } from 'sidecar-utility-library'

/**
 * This function will determine if a user has access to certain information If
 * the info is protected and the user does not have access, then either an
 * alternate component will be shown, or the information is just omitted.
 *
 * BASE Access - Can see all information including PHI and Contact Info PHI
 * Access - Can see all information except Contact Info CONTACT_INFO Access -
 * Can only see contact info
 */

export const hasHipaaAccess = (type, memberUuid) => {
  // Impersonating admins have full access — the feature flag already gates
  // whether they can reach expense pages at all.
  if (webStorage.getItem('isAdmin') === 'true') {
    return true
  }

  // checks authedUser's access level against accessMemberMap to determine
  // what this user is allowed to see.
  const accessMap = JSON.parse(webStorage.getItem('accountMemberAccessMap'))
  const canSeeBASE = accessMap?.BASE.includes(memberUuid)
  const canSeePHI = accessMap?.PHI.includes(memberUuid)
  const canSeeCONTACT_INFO = accessMap?.CONTACT_INFO.includes(memberUuid)

  // if the user has access to this type of info, render that info
  switch (type) {
    case 'PHI':
      if (canSeePHI) {
        return true
      } else {
        return false
      }
    case 'CONTACT_INFO':
      if (canSeeCONTACT_INFO) {
        return true
      } else {
        return false
      }
    case 'BASE':
      if (canSeeBASE) {
        return true
      } else {
        return false
      }
    //No default, if you aren't passing a valid type, you should get a warning/undefined
  }
}
